import { ofType } from 'redux-observable'

import APP, { epicErrorHandler, epicResponseHandler, epicServerRequest } from 'app'

import { catchError, filter, map, mergeMap, takeUntil } from 'rxjs/operators'

export const TOURNAMENT_PAGE_RELATION_FETCH = 'TOURNAMENT_PAGE_RELATION_FETCH'
export const TOURNAMENT_PAGE_RELATION_FETCH_ERROR = 'TOURNAMENT_PAGE_RELATION_FETCH_ERROR'
export const TOURNAMENT_PAGE_RELATION_FETCH_FULFILLED = 'TOURNAMENT_PAGE_RELATION_FETCH_FULFILLED'
export const TOURNAMENT_PAGE_RELATION_FETCH_CANCELED = 'TOURNAMENT_PAGE_RELATION_FETCH_CANCELED'

export const tournamentRelationFetch = (tournamentId) => ({
  payload: tournamentId,
  type: TOURNAMENT_PAGE_RELATION_FETCH,
})

export const tournamentRelationFetchFulfilled = (payload) => ({
  payload,
  type: TOURNAMENT_PAGE_RELATION_FETCH_FULFILLED,
})

export const tournamentRelationFetchCanceled = () => ({
  payload: null,
  type: TOURNAMENT_PAGE_RELATION_FETCH_CANCELED,
})

export const tournamentRelationFetchError = (payload) => ({
  payload,
  type: TOURNAMENT_PAGE_RELATION_FETCH_ERROR,
})

export const tournamentRelationFetchEpic = (action$) =>
  action$.pipe(
    ofType(TOURNAMENT_PAGE_RELATION_FETCH),
    filter(() => !!APP.AUTH_HEADERS.Authorization),
    mergeMap((action) =>
      epicServerRequest('get', `${APP.api_url}/sports/tournament/${action.payload}/relation`, action).pipe(
        map(epicResponseHandler(tournamentRelationFetchFulfilled, action)),
        takeUntil(action$.pipe(ofType(TOURNAMENT_PAGE_RELATION_FETCH_CANCELED))),
        catchError(epicErrorHandler(tournamentRelationFetchError, action)),
      ),
    ),
  )
